import { AppGetterNames } from './keys'
import { AppState, USER_ROLE_TYPES } from './types'

/* tslint:disable:no-shadowed-variable */
export const getters = {
  [AppGetterNames.userFullName]: (state: AppState): string => {
    if (state.userFirstName || state.userLastName) {
      return [state.userFirstName, state.userLastName].filter(Boolean).join(' ')
    } else {
      return state.userId
    }
  },
  [AppGetterNames.isAdminUser]: (state: AppState): boolean => {
    console.log('user roles:')
    console.log(state.userRoles)
    return state.userRoles.some(role => role === USER_ROLE_TYPES.ADMIN)
  },
  [AppGetterNames.isRocheConsultant]: (state: AppState): boolean => {
    return state.userRoles.some(role => role === USER_ROLE_TYPES.ROCHE_CONSULTANT)
  },
  [AppGetterNames.isCareTeamUser]: (state: AppState): boolean => {
    return state.userRoles.some(role => role === USER_ROLE_TYPES.CARE_TEAM)
  },
  [AppGetterNames.isNursingHomeUser]: (state: AppState): boolean => {
    return state.userRoles.some(role => role === USER_ROLE_TYPES.NURSING_HOME)
  },
  [AppGetterNames.isExecUser]: (state: AppState): boolean => {
    return state.userRoles.some(role => role === USER_ROLE_TYPES.EXEC)
  },
}
